const isAuth = () =>
    !!(localStorage.getItem(`Meteor.loginToken`) && localStorage.getItem(`Meteor.userId`));

export default isAuth;
